// TotalExecutionsData.jsx

import React from 'react';
import {
  Chart,
  ChartTitle,
  ChartLegend,
  ChartTooltip,
  ChartCategoryAxis,
  ChartCategoryAxisItem,
  ChartValueAxis,
  ChartValueAxisItem,
  ChartSeries,
  ChartSeriesItem,
} from '@progress/kendo-react-charts';
import {
  LABEL_COLOUR,
  MAJOR_GRID_LINES,
} from '../../../../constants/dashboardConfig';
/**
 * A Bar chart to show both Run Sets and Test Cases successfully executed
 * @param {*} reportData of success By Module
 * @returns
 */
export const AffectedFilesData = ({ reportData = '' }) => {
  const categories = reportData?.map((item) => item.repo_name);
  const dataCounts = reportData?.map((item) => item.count);
  const [containerWidth, setContainerWidth] = React.useState(800);
  // Calculate if we need horizontal scroll based on label overlap
  const calculateScrollNeed = () => {
    if (!reportData || reportData.length === 0) {
      return {
        needsScroll: false,
        calculatedWidth: containerWidth,
        labelStep: 1,
      };
    }

    const avgLabelWidth = 80; // Approximate width of module name labels
    const minSpaceBetweenLabels = 18; // Minimum space between labels
    const requiredSpacePerLabel = avgLabelWidth + minSpaceBetweenLabels;
    const totalRequiredWidth = reportData.length * requiredSpacePerLabel;
    const availableWidth = containerWidth - 100; // Account for padding and axis

    return {
      needsScroll: totalRequiredWidth > availableWidth,
      calculatedWidth: Math.max(availableWidth, totalRequiredWidth),
      labelStep: Math.max(1, Math.ceil(totalRequiredWidth / availableWidth)),
    };
  };
  const { needsScroll, calculatedWidth, labelStep } = calculateScrollNeed();
  return (
    <div className="affected-files-chart">
      <Chart>
        <ChartTitle
          text="Affected Files by Repository"
          color={LABEL_COLOUR}
          position="top"
        />
        <ChartLegend visible={false} />
        <ChartTooltip format="{0}" />
        <ChartCategoryAxis>
          <ChartCategoryAxisItem
            categories={categories}
            majorGridLines={MAJOR_GRID_LINES}
            minorGridLines={{
              visible: true,
              color: '#e0e0e0',
              width: 1,
            }}
            title={{ text: 'Repository', color: LABEL_COLOUR }}
            labels={{
              color: LABEL_COLOUR,
              rotation: 'auto',
              step: needsScroll ? 1 : labelStep, // Show all labels when scrolling, skip when fitting
              skip: needsScroll ? 0 : Math.max(0, labelStep - 1), // No skip when scrolling
            }}
          />
        </ChartCategoryAxis>
        <ChartValueAxis>
          <ChartValueAxisItem
            labels={{
              color: LABEL_COLOUR,
              rotation: 'auto',
              step: Math.ceil(categories.length / 10),
            }}
            title={{ text: 'Files Affected', color: LABEL_COLOUR }}
            majorGridLines={MAJOR_GRID_LINES}
          />
        </ChartValueAxis>
        <ChartSeries>
          <ChartSeriesItem
            type="column" // Change to "bar" or "line" as needed
            data={dataCounts}
            name="Files Affected"
            color={(e) => '#9c27b0'}
          />
        </ChartSeries>
      </Chart>
    </div>
  );
};

export default AffectedFilesData;
